/**
 * główne menu aplikacji
 */

export default [
  {
    path: '/',
    name: 'home',
    title: 'Strona główna',
    userType: 'all',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    title: 'Zaloguj się',
    userType: 'guest',
    component: () => import('../views/Login.vue')
  },
  // po zalogowaniu
  {
    path: '/dashboard',
    name: 'dashboard',
    title: 'Kokpit',
    userType: 'logged',
    component: () => import('../views/AfterLogin.vue')
  },
  // reset hasła
  {
    path: '/reset-password',
    name: 'reset-password',
    title: 'Zresetuj hasło',
    userType: 'guest',
    component: () => import('../views/ResetPassword.vue')
  },
  // rejestracja
  {
    path: '/register',
    name: 'register',
    title: 'Zarejestruj się',
    userType: 'guest',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    title: 'Admin',
    userType: 'admin',
    component: () => import('../views/Admin.vue')
  }
]
